import Vue from 'vue'

// 共享的实时时钟。原来在 Index / Header / Renjiadao / Video / UserAddNew 各写一份，
// 且定时器从不清理。这里统一提供，组件销毁时自动停止。
export default Vue.extend({
  data() {
    return {
      now1: '',
      // 定时器句柄，不参与渲染
      clockTimer: 0 as unknown as ReturnType<typeof setTimeout>,
    }
  },
  mounted() {
    this.tick()
  },
  beforeDestroy() {
    clearTimeout(this.clockTimer)
  },
  methods: {
    tick() {
      const now = new Date()
      const pad = (n: number) => String(n).padStart(2, '0')
      this.now1 = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ` +
        `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`
      this.clockTimer = setTimeout(this.tick, 1000)
    },
  },
})
